import { render, staticRenderFns } from "./ExcalidrawModalWrapper.vue?vue&type=template&id=67fd2cc6&scoped=true&"
import script from "./ExcalidrawModalWrapper.vue?vue&type=script&lang=js&"
export * from "./ExcalidrawModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ExcalidrawModalWrapper.vue?vue&type=style&index=0&id=67fd2cc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd2cc6",
  null
  
)

export default component.exports